import React from 'react';
import {Route, Routes} from 'react-router-dom';


import ProtectedRoute from "../components/mainsite/ProtectedRoute";

import NotFoundPage from "../pages/NotFoundPage";
import HomePage from "../pages/users/home";
import LoginPage from "../pages/users/login";
import ProfilePage from "../pages/users/profile";
import ReportList from "../pages/report/ReportList";
import ReportViewer from "../pages/report/ReportViewer";
import ForgotPasswordPage from "../pages/users/forgotpassword";
import ResetPassword from "../pages/users/resetpassword";

const RouterConfig = (props) => {
    const {authUser, setAuthUser} = props
    console.log('RouterConfig authUser', authUser)

    return (
        <Routes>
            <Route path="/" element={<HomePage/>}/>
            <Route path="/login" element={<LoginPage setAuthUser={setAuthUser}/>}/>
            <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>
            <Route path="/reset-password-confirm/:uidb64/:token" element={<ResetPassword/>}/>
            <Route path="/404" element={<NotFoundPage />} />

            {/* Routes protected by ProtectedRoute */}
            <Route
                path="/profile"
                element={
                    <ProtectedRoute authUser={authUser}>
                        <ProfilePage/>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/report-list"
                element={
                    <ProtectedRoute authUser={authUser}>
                        <ReportList title="Rapport d'Activité" type="rapport-activite"/>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/report-list-appel"
                element={
                    <ProtectedRoute authUser={authUser}>
                        <ReportList title="Statistique d'appel" type="appel"/>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/report/:id"
                element={
                    <ProtectedRoute authUser={authUser}>
                        <ReportViewer />
                    </ProtectedRoute>
                }
            />
        </Routes>

    );
};

export default RouterConfig;